<template>
    <div class="kris-documents-box">
      <div class="h2">Коллективно - договорное регулирование</div>
      <ul class="kris-doclist">
        <ekis-file v-bind:key="item.id" v-for="item in data" title="Коллективный договор" :ext="item.ext" :link="item.link" />
      </ul>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import File from './File'
export default {
  name: 'CollAgreement',
  components: {
    'ekis-file': File
  },
  computed: {
    ...mapState({
      'data': 'dataCollAgreement'
    })
  },
  created () {
    this.$store.dispatch('getDataCollAgreement')
  }
}
</script>

<style scoped>

</style>
